import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import { IOpioidConversionFactor } from '../../entities/OpioidConversionFactor/OpioidConversionFactor';

export class OpioidConversionFactorApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/OpioidConversionFactor`;

    public static async getAll(versionID?: number): Promise<IOpioidConversionFactor[]> {
        const params = new URLSearchParams();
        if (versionID) params.append('versionID', versionID.toString());
        
        const queryString = params.toString();
        const path = queryString ? `${this.baseApiUrl}?${queryString}` : this.baseApiUrl;
        
        return this.sendApiRequest<IOpioidConversionFactor[]>({
            method: HttpMethodEnum.GET,
            path: path,
        });
    }
}
